import { MotorStatusMdl } from './MotorStatusMdl';
import { ProductMaster,GenderMaster,IdTypeMaster,LicenseTypeMaster,VehiclePlateLetterMaster,VehcielUsageMaster,VehcielDefinitionMaster,MarStatusMaster,CoverMaster,CityMaster,NationalityMaster,MakeMaster,ModelMaster,VechilePlateTypeMaster,YearMaster,RegionMaster,VechileTypeMaster,MakeModelMaster,DiscountModel,VechileColorMaster,VehicleEquippedMaster,RestraintsMaster,VehicleBodyMaster,SmokeMaster,HealthStatusMaster,prevCompanyMdl,streetMdl,DistMdl,DeductableMaster,RepairTypeMaster,AccesMater,BankMaster, EducationMdl, TransmissionMdl, AntiLockBrakingMdl, AutomaticBrakingMdl, CruiseControlMdl, AdaptiveCruiseMdl, RearParkingSensorMdl, FrontSensorMdl, FrontCameraMdl, RearCameraMdl, DegreeCameraMdl, FireExtinguisherMdl, ExpectedMileageMdl, numYearMdl, YesNoMdl, ProfessionMdl,RelationMdl,VehicleKeptMdl } from "./BindMdl";
import { TPLProposal } from './TPLProposal';
import { mdlLicenceForEachCountryList } from './mdlLicenceForEachCountryList';
import { mdlChildrenUnder16List } from './mdlChildrenUnder16List';

export class RenewBindMdl
{
    public ProductList: Array<ProductMaster>=new Array<ProductMaster>() ;
    public GenderList: Array<GenderMaster>=new Array<GenderMaster>();
    public IDTypeList: Array<IdTypeMaster>=new Array<IdTypeMaster>() ;
    public LicenceTypeList: Array<LicenseTypeMaster>=new Array<LicenseTypeMaster>() ;
    public VechilePlateList: Array<VehiclePlateLetterMaster>=new Array<VehiclePlateLetterMaster>();
    public  VehcielUsageList: Array<VehcielUsageMaster>=new Array<VehcielUsageMaster>();
    public VehcielDefinitionList: Array<VehcielDefinitionMaster>=new Array<VehcielDefinitionMaster>();
    public MarStatusList: Array<MarStatusMaster>=new Array<MarStatusMaster>() ;
    public CoverMasterList: Array<CoverMaster>=new Array<CoverMaster>();
    public CityMasterList: Array<CityMaster>=new Array<CityMaster>() ;
    public NationalityMasterList: Array<NationalityMaster>=new Array<NationalityMaster>();
    public MakeMasterList: Array<MakeMaster>=new Array<MakeMaster>();
    public ModelMasterList: Array<ModelMaster>=new Array<ModelMaster>();
    public VechilePlateTypeMasterList: Array<VechilePlateTypeMaster>=new Array<VechilePlateTypeMaster>();
    public YearList: Array<YearMaster>=new Array<YearMaster>();
    public TplObj: TPLProposal=new TPLProposal();
    public RegionMasterList: Array<RegionMaster>=new Array<RegionMaster>();
    public VechileTypeMasterList: Array<VechileTypeMaster>=new Array<VechileTypeMaster>();
    public MakeModelMasterList: Array<MakeModelMaster>=new Array<MakeModelMaster>();
    public discountMasterList: Array<DiscountModel>=new Array<DiscountModel>();
    public VechileColorList: Array<VechileColorMaster>=new Array<VechileColorMaster>();
    public equippedList: Array<VehicleEquippedMaster>=new Array<VehicleEquippedMaster>();
    public restrainList: Array<RestraintsMaster>=new Array<RestraintsMaster>();
    public  bodyList: Array<VehicleBodyMaster>=new Array<VehicleBodyMaster>();
    public smokeList: Array<SmokeMaster>=new Array<SmokeMaster>();
    public healthList: Array<HealthStatusMaster>=new Array<HealthStatusMaster>() ;
    public companyList: Array<prevCompanyMdl>=new Array<prevCompanyMdl>();
    public streetList: Array<streetMdl>=new Array<streetMdl>();
    public disList: Array<DistMdl>=new Array<DistMdl>();
    public deductableList: Array<DeductableMaster>=new Array<DeductableMaster>() ;
    public repairList: Array<RepairTypeMaster>=new Array<RepairTypeMaster>() ;
    public accList: Array<AccesMater>=new Array<AccesMater>() ;
    public bankList: Array<BankMaster>=new Array<BankMaster>();

    public eduList: Array<EducationMdl>=new Array<EducationMdl>();
    public profList: Array<ProfessionMdl>=new Array<ProfessionMdl>();
    public transmissionList: Array<TransmissionMdl>=new Array<TransmissionMdl>() ;
    public antiLockBrakingList: Array<AntiLockBrakingMdl>=new Array<AntiLockBrakingMdl>();
    public autoBrakingList: Array<AutomaticBrakingMdl>=new Array<AutomaticBrakingMdl>();
    public crusieControlList: Array<CruiseControlMdl>=new Array<CruiseControlMdl>();
    public adaptiveCruiseList: Array<AdaptiveCruiseMdl>=new Array<AdaptiveCruiseMdl>();
    public parkingSensorList: Array<RearParkingSensorMdl>=new Array<RearParkingSensorMdl>();
    public frontSensorList: Array<FrontSensorMdl>=new Array<FrontSensorMdl>();
    public frontCamList: Array<FrontCameraMdl>=new Array<FrontCameraMdl>();
    public rearCamList: Array<RearCameraMdl>=new Array<RearCameraMdl>();
    public degreeCamList: Array<DegreeCameraMdl>=new Array<DegreeCameraMdl>();
    public ExtinguisherList: Array<FireExtinguisherMdl>=new Array<FireExtinguisherMdl>();
    public mileageList: Array<ExpectedMileageMdl>=new Array<ExpectedMileageMdl>();
    public NumYearList: Array<numYearMdl>=new Array<numYearMdl>();
    public yesnoList: Array<YesNoMdl>=new Array<YesNoMdl>();

    public relationList:  Array<RelationMdl>=new  Array<RelationMdl>();
    public vehicleKeptList:Array<VehicleKeptMdl>=new Array<VehicleKeptMdl>();
    public schemeObj: SchemeMdl=new SchemeMdl();
    public RoadConvictionList: Array<RoadConviction> = new Array<RoadConviction>();
  
    public LicenceForEachCountryList: Array<mdlLicenceForEachCountryList> = new Array<mdlLicenceForEachCountryList>();
    public ChildrenUnder16List: Array<mdlChildrenUnder16List> = new Array<mdlChildrenUnder16List>();
    
    public  st: MotorStatusMdl=new MotorStatusMdl() ;
}

export class SchemeMdl
{
   public  TPLSchemeCode: string;
   public  CompSchemeCode: string;
}

export class RoadConviction
{
    public RoadConviction_ID: number;
    public RoadConviction_Eng: string;
    public RoadConviction_Ar: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/RenewBindMdl.ts